import {adminPolicy} from "./admin";
const policyNamespace = "period-extension";
const policyMap = new Map([[`${policyNamespace}/manage`, adminPolicy]]);


export default policyMap;
